<p-orderList
    [value]="items"
    [listStyle]="{ height: '25rem' }"
    [dragdrop]="true"
>
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center">
            {{ title | translate }}
            <app-button
                [pTooltip]="tooltip | translate"
                icon="pi-plus"
                (clickEvent)="add.emit()"
            />
        </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
        <div class="flex flex-wrap p-2 align-items-center gap-3">
            <div class="flex-1 flex align-items-center gap-2">
                <app-button
                    [style]="{ zIndex: 1 }"
                    icon="pi-pencil"
                    [text]="true"
                    (clickEvent)="edit.emit(item)"
                ></app-button>
                <span class="font-bold">{{ item.title }}</span>
            </div>
            <app-delete-button
                [style]="{ zIndex: 1 }"
                [text]="true"
                [hideLabel]="true"
                confirmationType="none"
                (clickEvent)="remove.emit(item)"
            ></app-delete-button>
        </div>
    </ng-template>
</p-orderList>
